// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';

class State {
  value = '';
}
export default class InviteSearcher extends React.Component {
  state = new State();

  handleChange = ({ target }) => {
    this.setState({ value: target.value });
  };

  findByInvite = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { findByInvite } = this.props;
    const { value } = this.state;
    findByInvite(value);
  };
  render() {
    const { value } = this.state;
    return (
      <Fragment>
        <FormGroup
          style={{
            paddingLeft: '0px',
            width: '155px',
            display: 'inline-block',
            paddingRight: '0px',
          }}
        >
          <FormControl
            onChange={this.handleChange}
            placeholder='Enter invite code'
            value={value}
            type='text'
          />
        </FormGroup>
        <button
          type='submit'
          onClick={this.findByInvite}
          style={{ marginRight: '0px', marginTop: '-3px', marginLeft: '16px' }}
          disabled={value.length === 0}
          className='btn btn-primary'
        >
          Open by invite
        </button>
      </Fragment>
    );
  }
}
